import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  variant?: 'dots' | 'pulse' | 'gradient' | 'orbiting' | 'simple'
  text?: string
  className?: string
}

const LoadingSpinner = ({ 
  size = 'medium', 
  variant = 'simple', 
  text,
  className = '' 
}: LoadingSpinnerProps) => {
  const renderSpinner = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className={`loading-dots ${size}`}>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        )
      
      case 'pulse':
        return (
          <div className={`loading-pulse ${size}`}>
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
          </div>
        )
      
      case 'orbiting':
        return (
          <div className={`loading-orbiting ${size}`}>
            <div className="orbit">
              <div className="planet"></div>
            </div>
            <div className="orbit orbit-2">
              <div className="planet planet-2"></div>
            </div>
            <div className="orbit orbit-3">
              <div className="planet planet-3"></div>
            </div>
          </div>
        )
      
      case 'simple':
      default:
        return (
          <div className={`loading-simple ${size}`}>
            <div className="simple-spinner"></div>
          </div>
        )
        
      case 'gradient':
        return (
          <div className={`loading-gradient ${size}`}>
            <div className="gradient-spinner">
              <div className="spinner-inner"></div>
            </div>
          </div>
        )
    }
  }

  return (
    <div className={`loading-spinner-container ${className}`}>
      <div 
        className={`loading-${variant} ${size}`} 
        role="status" 
        aria-label="Loading..."
        data-testid="loading-spinner"
      >
        {renderSpinner()}
      </div>
      {text && <div className="loading-text">{text}</div>}
    </div>
  )
}

export default LoadingSpinner 